/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { FC } from 'react';
import { G17EcoHeader, G17EcoHeaderProps } from './G17EcoHeader';
import SiteAlerts from '../site-alerts';
import './styles.scss';
import { Toaster } from 'react-hot-toast';

export interface HeaderProps extends G17EcoHeaderProps {
  className?: string;
}

const Header: FC<HeaderProps> = (props) => {
  return <div className={`header-container ${props.className ?? ''}`}>
    <header className='d-flex flex-column'>
      <section className='g17eco-header p-1'>
        <G17EcoHeader {...props} />
      </section>
      <SiteAlerts />
      <Toaster position='bottom-left' />
      {props.children ? <section className='app-header'>{props.children}</section> : <></>}
    </header>
  </div>
}

export default Header;
